import {
  getTrackingByShopId
} from "./chunk-Z3IWEC4R.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";

// src/services/getTrackingByShopId/getTrackingByShopId.ts
function getTrackingByShopId2(shopId, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "getTrackingByShopId");
  return getTrackingByShopId(shopId, _apiConfig);
}

export {
  getTrackingByShopId2 as getTrackingByShopId
};
